/**
 * 医生操作员模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增操作员
export const scanAdd = (params) => {
  return req.post('/order/scan/user', params);
}

// 修改操作员信息
export const scanEdit = (params) => {
  return req.put('/order/scan/user', params);
}

// 获取操作员列表
export const scanList = (params) => {
  return req.get('/order/scan/user/list', params);
}

// 获取操作员详情
export const scanInfo = (scanCodeUserId) => {
  return req.get(`/order/scan/user/${scanCodeUserId}`);
}

// 获取操二维码
export const scanImg = (scanCodeUserId) => {
  return req.get(`/order/scan/user/getBindCode/${scanCodeUserId}`);
}